import React from 'react';
import { withStyles } from '@mui/styles';

const styles = theme => ({
  root: {
    width: '100%',
    margin: 'auto',
    backgroundColor: theme.palette.background.paper,
  },
  textroot: {
    width: '100%',
    margin: 'auto',
  },
  filePreviewContainer: {
    marginTop: 8,
  },
  filePreviewHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 8,
    color: theme.palette.text.secondary,
  },
  fileIcon: {
    marginRight: 8,
    color: theme.palette.primary.main,
  },
  filePreviewURL: {
    height: 309,
    border: '1px solid #C4C4C4',
    boxSizing: 'border-box',
    borderRadius: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 14,
    padding: '16px',
    overflow: 'auto',
    backgroundColor: theme.palette.action.hover,
    wordBreak: 'break-all',
    maxWidth: '100%',
    whiteSpace: 'normal',
    textAlign: 'center',
  },
  noFileMessage: {
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
  },
});

class FilePreview extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes } = this.props;

    try {
      const fileData = this.props.data?.answer_data_default;

      return (
        <div className={classes.root}>
          <div className={classes.filePreviewContainer}>
            <div className={classes.filePreviewURL}>
              {fileData ? (
                fileData
              ) : (
                <span className={classes.noFileMessage}>No file data available to preview</span>
              )}
            </div>
          </div>
        </div>
      );
    } catch (e) {
      return <h5>Error encountered</h5>;
    }
  }
}

export default withStyles(styles)(FilePreview);
